import { fuego } from '@store/firebase/index';
import { AUTH_TYPE } from '@typings/common/authorizationType';
import { CollectionPath } from '@typings/collections.enum';
import { Inotification } from '@typings/notification/notification.interface';
import { NOTI_TYPE } from '@typings/notification/notificationType';

type Props = {
  data: Inotification;
  receiver: string | null;
};
export async function addNotification({ data, receiver }: Props) {
  if (!receiver) return;
  const ref = fuego.db.collection(CollectionPath.USERS).doc(receiver);
  const notiRef = ref.collection(CollectionPath.NOTIFICATIONS);

  return notiRef.add(data);
}

export async function addGroupNotification({ data, receiverIdList }) {
  const ref = fuego.db.collection(CollectionPath.USERS);

  return receiverIdList.map((docId) => {
    if (!docId) return;
    const notiRef = ref.doc(docId).collection(CollectionPath.NOTIFICATIONS);
    return notiRef.add(data);
  });
}

export async function addMasterGroupNotification({ data }: { data: Inotification }) {
  // 1. masterNotifications Firestore 설정 확인
  const statusSnap = await fuego.db
    .collection(CollectionPath.STATUS)
    .doc('statusSetting')
    .get();
  const mn = (statusSnap.data()?.masterNotifications ?? {}) as {
    guestbook?: boolean;
    gift?: boolean;
  };

  const typeGateMap: Partial<Record<string, boolean>> = {
    [NOTI_TYPE.GUESTBOOK]: mn.guestbook ?? true,
    [NOTI_TYPE.PRESENT]: mn.gift ?? true,
  };

  // 해당 타입이 명시적으로 false이면 발송 중단
  if (typeGateMap[data.type] === false) return;

  // 2. master 목록 조회
  const ref = fuego.db.collection(CollectionPath.USERS);
  const masterSnap = await ref
    .where('authorizationType', '==', AUTH_TYPE.MASTER)
    .get();

  if (masterSnap.empty) return;

  // 3. batch write로 성능 개선 (개별 add() 대신)
  const batch = fuego.db.batch();
  masterSnap.docs.forEach((doc) => {
    const notiRef = ref
      .doc(doc.id)
      .collection(CollectionPath.NOTIFICATIONS)
      .doc();
    batch.set(notiRef, data);
  });
  return batch.commit();
}

export async function updateNotiRead({ userId, notificationID }) {
  const ref = fuego.db.collection(CollectionPath.USERS).doc(userId);
  const notiRef = ref
    .collection(CollectionPath.NOTIFICATIONS)
    .doc(notificationID);

  return notiRef.set({ is_seen: true }, { merge: true });
}

export async function allNotiRead({ userId }) {
  const ref = fuego.db
    .collection(CollectionPath.USERS)
    .doc(userId)
    .collection(CollectionPath.NOTIFICATIONS);

  return ref.get().then((res) =>
    res.docs.map((doc) => {
      return ref.doc(doc.id).set({ is_seen: true }, { merge: true });
    }),
  );
}
